import './app.scss';
import * as Sentry from '@sentry/solid';
import CesiumMap from '../CesiumMap/CesiumMap';
import { StateContextProvider } from '../context';
import Guestbook from '../Guestbook/Guestbook';
import Header from '../Header/Header';
import Bio from '../Bio/Bio';
import Chatbox from '../Llm/Chatbox';
import { InfoBox } from '../CesiumMap/InfoBox/InfoBox';
import { MapContextProvider } from '../CesiumMap/MapContext';
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/joshhussey\.ca/],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
});
function App() {
    return (
        <>
            <StateContextProvider>
                <MapContextProvider>
                    <Chatbox />
                    <CesiumMap />
                    <Header />
                    <Bio />
                    <InfoBox />
                    <Guestbook />
                </MapContextProvider>
            </StateContextProvider>
        </>
    )
}

export default App
